var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-layout",class:{basic: _vm.basic}},[_c('header-bar',{staticClass:"base-layout__header"}),_c('div'),_c('main',{staticClass:"base-layout__content"},[_c('column-block',[_vm._t("default")],2)],1),_c('footer-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }